// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatasolvbtc } from "../../../icons/full/build/icon-statasolvbtc.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatasolvbtcIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatasolvbtc.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatasolvbtcIcon.displayName = 'StatasolvbtcIcon';
}

export default StatasolvbtcIcon;